module.exports = __webpack_public_path__ + "img/inbox-fill.6bd2895e.svg";